export default "<i class=\"icon-plus1 arrow slideInDown\" container=\"body\" placement=\"left\"></i>\r\n"